import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StaffService, UiSafeStaff } from 'src/app/api';
import { DropdownOptionService } from 'src/app/ui/dropdowns/dropdown-option.service';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownOption } from 'src/app/ui/uiInterfaces';
import { MessageService } from 'primeng/api';
import { CustomerService } from 'src/app/api';
import { Router } from '@angular/router';
import { StaffDropdownComponent } from 'src/app/ui/staff-dropdown/staff-dropdown.component';
import { NgIf } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-create-lead',
  imports: [StaffDropdownComponent, FormsModule, NgIf, SelectModule, ButtonModule, ReactiveFormsModule, DialogModule, InputTextModule],
  templateUrl: './create-lead.component.html',
  styleUrl: './create-lead.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateLeadComponent implements OnInit {

  staffOptions: UiSafeStaff[] = []
  loadCustomerSize: DropdownOption[] = []
  recruitingStatus: DropdownOption[] = []
  newCustomerId: number = 0;

  dialogVisible: boolean = true;

  createCustomer: FormGroup

  constructor(
    private staffService: StaffService,
    private dropdownOtionService: DropdownOptionService,
    private messageService: MessageService,
    private customerService: CustomerService,
    private router: Router
  ) {
    this.createCustomer = new FormGroup({
      groupname: new FormControl('', [Validators.required]),
      individual: new FormControl('', [Validators.required]),
      recruiterId: new FormControl(0, [Validators.required]),
      status: new FormControl(0, [Validators.required]),
    });
  }


  showDialog() {
    this.dialogVisible = true;
  }

  closeDialog() {
    this.dialogVisible = false;
    this.router.navigate(['mission-control']);
  }

  onSuccess() {
    this.dialogVisible = false;
    this.router.navigate(['contact-card', this.newCustomerId]);
  }

  ngOnInit() {
    this.staffService.getRecruiterList().subscribe(staff => {
      this.staffOptions = staff
    })
    this.loadCustomerSize = this.dropdownOtionService.newCustomerSize()
    this.recruitingStatus = this.dropdownOtionService.recruitingStatus()
  }

  createLead() {
    if (this.createCustomer.valid) {
      const formValue = this.createCustomer.value;  

      const recruiterId = formValue.recruiterId?.id;
      if (!recruiterId) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'Recruiter ID is required',
          life: 3000,
        });
        return;
      }

      const payload = {
        groupname: formValue.groupname, 
        individual: formValue.individual,
        recruiterId: recruiterId,
        status: Number(formValue.status),
      };
      this.customerService.createNewLead(payload).subscribe({
        next: (response) => {
          this.newCustomerId = response.id;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Lead created successfully',
            life: 3000,
          });
          this.onSuccess();
          this.createCustomer.reset();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to create lead',
            life: 3000,
          });
        },
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please fill out all required fields',
        life: 3000,
      });
    }
  }

}
